import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Drawer, DrawerContent, DrawerOverlay, Flex, IconButton } from '@tq/ui-components';
import { UseDisclosureProps } from '@tq/ui-components/dist/hooks';
import { tqc } from '@tq/ui-components/dist/system';

import { MobileMenuDrawerItems } from './MobileMenuDrawerItems';

export const MobileMenuDrawer: React.FC<UseDisclosureProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('mobile_menu');

  return (
    <Drawer size='xl' isOpen={!!isOpen} placement='right' onClose={() => onClose?.()}>
      <DrawerOverlay />
      <DrawerContent w='80%' aria-label={t('drawer_menu_aria_label', 'Drawer menu')}>
        <Flex
          alignItems='center'
          justifyContent='space-between'
          borderBottom={`1px solid ${COLOURS.blue[600]}`}
          h='65px'
          px={8}
        >
          <tqc.p fontSize='lg'>
            <strong>{t('consultee_hub', 'Consultee Hub')}</strong>
          </tqc.p>

          <IconButton
            icon={<FaTimes />}
            aria-label={t('close_mobile_menu_button', 'Close drawer menu button')}
            onClick={onClose}
          />
        </Flex>
        <MobileMenuDrawerItems onClose={onClose} />
      </DrawerContent>
    </Drawer>
  );
};
